import './Content.css';
import ContentTop from '../../components/ContentTop/ContentTop.jsx'
import ContentMain from '../../components/ContentMain/ContentMain.jsx';
const Content = () => {
  return (
    <div className='main-content'>
      <ContentTop/>
      <ContentMain/>
    </div>
  )
}

export default Content